module.exports = __webpack_public_path__ + "static/media/schoolshoppinglist3.8de3a27d.jpg";